//Nabijash
import Nabijash1 from "../assets/images/nabijash/Screenshot_1.png";
import Nabijash2 from "../assets/images/nabijash/Screenshot_2.png";
import Nabijash3 from "../assets/images/nabijash/Screenshot_3.png";
import Nabijash4 from "../assets/images/nabijash/Screenshot_4.png";
import Nabijash5 from "../assets/images/nabijash/Screenshot_5.png";
import Nabijash6 from "../assets/images/nabijash/Screenshot_6.png";
import Nabijash7 from "../assets/images/nabijash/Screenshot_7.png";
import Nabijash1Thumb from "../assets/images/nabijash/Screenshot_1-thumb.png";
import Nabijash2Thumb from "../assets/images/nabijash/Screenshot_2-thumb.png";
import Nabijash3Thumb from "../assets/images/nabijash/Screenshot_3-thumb.png";
import Nabijash4Thumb from "../assets/images/nabijash/Screenshot_4-thumb.png";
import Nabijash5Thumb from "../assets/images/nabijash/Screenshot_5-thumb.png";
import Nabijash6Thumb from "../assets/images/nabijash/Screenshot_6-thumb.png";
import Nabijash7Thumb from "../assets/images/nabijash/Screenshot_7-thumb.png";
//Trihla
import Trilha1 from "../assets/images/trilha/Screenshot_1.png";
import Trilha2 from "../assets/images/trilha/Screenshot_2.png";
import Trilha3 from "../assets/images/trilha/Screenshot_3.png";
import Trilha4 from "../assets/images/trilha/Screenshot_4.png";
import Trilha5 from "../assets/images/trilha/Screenshot_5.png";
import Trilha6 from "../assets/images/trilha/Screenshot_6.png";
import Trilha1Thumb from "../assets/images/trilha/Screenshot_1-thumb.png";
import Trilha2Thumb from "../assets/images/trilha/Screenshot_2-thumb.png";
import Trilha3Thumb from "../assets/images/trilha/Screenshot_3-thumb.png";
import Trilha4Thumb from "../assets/images/trilha/Screenshot_4-thumb.png";
import Trilha5Thumb from "../assets/images/trilha/Screenshot_5-thumb.png";
import Trilha6Thumb from "../assets/images/trilha/Screenshot_6-thumb.png";

//Il Mirtilo
import IlMirtilo1 from "../assets/images/ilmirtilo/Screenshot_1.png";
import IlMirtilo2 from "../assets/images/ilmirtilo/Screenshot_2.png";
import IlMirtilo3 from "../assets/images/ilmirtilo/Screenshot_3.png";
import IlMirtilo4 from "../assets/images/ilmirtilo/Screenshot_4.png";
import IlMirtilo5 from "../assets/images/ilmirtilo/Screenshot_5.png";
import IlMirtilo6 from "../assets/images/ilmirtilo/Screenshot_6.png";
import IlMirtilo1Thumb from "../assets/images/ilmirtilo/Screenshot_1-thumb.png";
import IlMirtilo2Thumb from "../assets/images/ilmirtilo/Screenshot_2-thumb.png";
import IlMirtilo3Thumb from "../assets/images/ilmirtilo/Screenshot_3-thumb.png";
import IlMirtilo4Thumb from "../assets/images/ilmirtilo/Screenshot_4-thumb.png";
import IlMirtilo5Thumb from "../assets/images/ilmirtilo/Screenshot_5-thumb.png";
import IlMirtilo6Thumb from "../assets/images/ilmirtilo/Screenshot_6-thumb.png";

//Dogs API
import DogsApi1 from "../assets/images/dogsapi/Screenshot_1.png";
import DogsApi2 from "../assets/images/dogsapi/Screenshot_2.png";
import DogsApi3 from "../assets/images/dogsapi/Screenshot_3.png";
import DogsApi4 from "../assets/images/dogsapi/Screenshot_4.png";
import DogsApi5 from "../assets/images/dogsapi/Screenshot_5.png";
import DogsApi1Thumb from "../assets/images/dogsapi/Screenshot_1-thumb.png";
import DogsApi2Thumb from "../assets/images/dogsapi/Screenshot_2-thumb.png";
import DogsApi3Thumb from "../assets/images/dogsapi/Screenshot_3-thumb.png";
import DogsApi4Thumb from "../assets/images/dogsapi/Screenshot_4-thumb.png";
import DogsApi5Thumb from "../assets/images/dogsapi/Screenshot_5-thumb.png";

//Portfolio
import Portfolio1 from "../assets/images/portfolio/Screenshot_1.png";
import Portfolio2 from "../assets/images/portfolio/Screenshot_2.png";
import Portfolio3 from "../assets/images/portfolio/Screenshot_3.png";
import Portfolio4 from "../assets/images/portfolio/Screenshot_4.png";
import Portfolio5 from "../assets/images/portfolio/Screenshot_5.png";
import Portfolio1Thumb from "../assets/images/portfolio/Screenshot_1-thumb.png";
import Portfolio2Thumb from "../assets/images/portfolio/Screenshot_2-thumb.png";
import Portfolio3Thumb from "../assets/images/portfolio/Screenshot_3-thumb.png";
import Portfolio4Thumb from "../assets/images/portfolio/Screenshot_4-thumb.png";
import Portfolio5Thumb from "../assets/images/portfolio/Screenshot_5-thumb.png";

//Cognity
import Cognity1 from "../assets/images/cognity/Screenshot_1.png"
import Cognity2 from "../assets/images/cognity/Screenshot_2.png"
import Cognity3 from "../assets/images/cognity/Screenshot_3.png"
import Cognity4 from "../assets/images/cognity/Screenshot_4.png"
import Cognity5 from "../assets/images/cognity/Screenshot_5.png"
import Cognity6 from "../assets/images/cognity/Screenshot_6.png"
import Cognity1Thumb from "../assets/images/cognity/Screenshot_1-thumb.png"
import Cognity2Thumb from "../assets/images/cognity/Screenshot_2-thumb.png"
import Cognity3Thumb from "../assets/images/cognity/Screenshot_3-thumb.png"
import Cognity4Thumb from "../assets/images/cognity/Screenshot_4-thumb.png"
import Cognity5Thumb from "../assets/images/cognity/Screenshot_5-thumb.png"
import Cognity6Thumb from "../assets/images/cognity/Screenshot_6-thumb.png"

//MDCX
import Mdcx1 from "../assets/images/mdcx/Screenshot_1.png"
import Mdcx2 from "../assets/images/mdcx/Screenshot_2.png"
import Mdcx3 from "../assets/images/mdcx/Screenshot_3.png"
import Mdcx4 from "../assets/images/mdcx/Screenshot_4.png"
import Mdcx5 from "../assets/images/mdcx/Screenshot_5.png"
import Mdcx6 from "../assets/images/mdcx/Screenshot_6.png"
import Mdcx7 from "../assets/images/mdcx/Screenshot_7.png"
import Mdcx8 from "../assets/images/mdcx/Screenshot_8.png"
import Mdcx1Thumb from "../assets/images/mdcx/Screenshot_1-thumb.png"
import Mdcx2Thumb from "../assets/images/mdcx/Screenshot_2-thumb.png"
import Mdcx3Thumb from "../assets/images/mdcx/Screenshot_3-thumb.png"
import Mdcx4Thumb from "../assets/images/mdcx/Screenshot_4-thumb.png"
import Mdcx5Thumb from "../assets/images/mdcx/Screenshot_5-thumb.png"
import Mdcx6Thumb from "../assets/images/mdcx/Screenshot_6-thumb.png"
import Mdcx7Thumb from "../assets/images/mdcx/Screenshot_7-thumb.png"
import Mdcx8Thumb from "../assets/images/mdcx/Screenshot_8-thumb.png"

//MDCX Campaign
import MdcxCampaign1 from "../assets/images/mdcxcampaign/Screenshot_1.png"
import MdcxCampaign2 from "../assets/images/mdcxcampaign/Screenshot_2.png"
import MdcxCampaign3 from "../assets/images/mdcxcampaign/Screenshot_3.png"
import MdcxCampaign4 from "../assets/images/mdcxcampaign/Screenshot_4.png"
import MdcxCampaign1Thumb from "../assets/images/mdcxcampaign/Screenshot_1-thumb.png"
import MdcxCampaign2Thumb from "../assets/images/mdcxcampaign/Screenshot_2-thumb.png"
import MdcxCampaign3Thumb from "../assets/images/mdcxcampaign/Screenshot_3-thumb.png"
import MdcxCampaign4Thumb from "../assets/images/mdcxcampaign/Screenshot_4-thumb.png"

//Medbot
import Medbot1 from "../assets/images/medbot/Screenshot_1.png"
import Medbot2 from "../assets/images/medbot/Screenshot_2.png"
import Medbot3 from "../assets/images/medbot/Screenshot_3.png"
import Medbot4 from "../assets/images/medbot/Screenshot_4.png"
import Medbot5 from "../assets/images/medbot/Screenshot_5.png"
import Medbot6 from "../assets/images/medbot/Screenshot_6.png"
import Medbot7 from "../assets/images/medbot/Screenshot_7.png"
import Medbot8 from "../assets/images/medbot/Screenshot_8.png"
import Medbot9 from "../assets/images/medbot/Screenshot_9.png"
import Medbot10 from "../assets/images/medbot/Screenshot_10.png"
import Medbot1Thumb from "../assets/images/medbot/Screenshot_1-thumb.png"
import Medbot2Thumb from "../assets/images/medbot/Screenshot_2-thumb.png"
import Medbot3Thumb from "../assets/images/medbot/Screenshot_3-thumb.png"
import Medbot4Thumb from "../assets/images/medbot/Screenshot_4-thumb.png"
import Medbot5Thumb from "../assets/images/medbot/Screenshot_5-thumb.png"
import Medbot6Thumb from "../assets/images/medbot/Screenshot_6-thumb.png"
import Medbot7Thumb from "../assets/images/medbot/Screenshot_7-thumb.png"
import Medbot8Thumb from "../assets/images/medbot/Screenshot_8-thumb.png"
import Medbot9Thumb from "../assets/images/medbot/Screenshot_9-thumb.png"
import Medbot10Thumb from "../assets/images/medbot/Screenshot_10-thumb.png"

//Karku
import Karku1 from "../assets/images/karku/Screenshot_1.png";
import Karku2 from "../assets/images/karku/Screenshot_2.png";
import Karku3 from "../assets/images/karku/Screenshot_3.png";
import Karku4 from "../assets/images/karku/Screenshot_4.png";
import Karku5 from "../assets/images/karku/Screenshot_5.png";
import Karku1Thumb from "../assets/images/karku/Screenshot_1-thumb.png";
import Karku2Thumb from "../assets/images/karku/Screenshot_2-thumb.png";
import Karku3Thumb from "../assets/images/karku/Screenshot_3-thumb.png";
import Karku4Thumb from "../assets/images/karku/Screenshot_4-thumb.png";
import Karku5Thumb from "../assets/images/karku/Screenshot_5-thumb.png";

//Articles
import Blog2 from "../assets/images/articles/blog2.png"
import Blog3 from "../assets/images/articles/blog3.png"
import Blog4 from "../assets/images/articles/blog4.png"

export interface Image {
  width: number;
  height: number;
  thumb: string;
  src: string;
  alt: string;
}

export const images: {
  nabijash: Image[];
  trilha: Image[];
  ilmirtilo: Image[];
  dogsapi: Image[];
  portfolio: Image[];
  cognity: Image[];
  mdcx: Image[];
  mdcxcampaign: Image[];
  medbot: Image[];
  karku: Image[];
  articles: {
    blog2: Image;
    blog3: Image;
    blog4: Image;
  };
} = {
  nabijash: [
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash1Thumb,
      src: Nabijash1,
      alt: "Nabijash Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash2Thumb,
      src: Nabijash2,
      alt: "Nabijash Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash3Thumb,
      src: Nabijash3,
      alt: "Nabijash Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash4Thumb,
      src: Nabijash4,
      alt: "Nabijash Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash5Thumb,
      src: Nabijash5,
      alt: "Nabijash Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash6Thumb,
      src: Nabijash6,
      alt: "Nabijash Screenshot #6",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash7Thumb,
      src: Nabijash7,
      alt: "Nabijash Screenshot #7",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Nabijash1Thumb,
      src: Nabijash1,
      alt: "Nabijash Screenshot #8",
    },
  ],
  trilha: [
    {
      width: 2559,
      height: 1326,
      thumb: Trilha1Thumb,
      src: Trilha1,
      alt: "Trilha Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Trilha2Thumb,
      src: Trilha2,
      alt: "Trilha Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Trilha3Thumb,
      src: Trilha3,
      alt: "Trilha Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Trilha4Thumb,
      src: Trilha4,
      alt: "Trilha Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Trilha5Thumb,
      src: Trilha5,
      alt: "Trilha Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Trilha6Thumb,
      src: Trilha6,
      alt: "Trilha Screenshot #6",
    },
  ],
  ilmirtilo: [
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo1Thumb,
      src: IlMirtilo1,
      alt: "IlMirtilo Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo2Thumb,
      src: IlMirtilo2,
      alt: "IlMirtilo Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo3Thumb,
      src: IlMirtilo3,
      alt: "IlMirtilo Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo4Thumb,
      src: IlMirtilo4,
      alt: "IlMirtilo Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo5Thumb,
      src: IlMirtilo5,
      alt: "IlMirtilo Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: IlMirtilo6Thumb,
      src: IlMirtilo6,
      alt: "IlMirtilo Screenshot #6",
    },
  ],
  dogsapi: [
    {
      width: 2559,
      height: 1326,
      thumb: DogsApi1Thumb,
      src: DogsApi1,
      alt: "DogsApi Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: DogsApi2Thumb,
      src: DogsApi2,
      alt: "DogsApi Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: DogsApi3Thumb,
      src: DogsApi3,
      alt: "DogsApi Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: DogsApi4Thumb,
      src: DogsApi4,
      alt: "DogsApi Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: DogsApi5Thumb,
      src: DogsApi5,
      alt: "DogsApi Screenshot #5",
    },
  ],
  portfolio: [
    {
      width: 2559,
      height: 1326,
      thumb: Portfolio1Thumb,
      src: Portfolio1,
      alt: "Portfolio Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Portfolio2Thumb,
      src: Portfolio2,
      alt: "Portfolio Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Portfolio3Thumb,
      src: Portfolio3,
      alt: "Portfolio Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Portfolio4Thumb,
      src: Portfolio4,
      alt: "Portfolio Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Portfolio5Thumb,
      src: Portfolio5,
      alt: "PortfolioScreenshot #5",
    },
  ],
  cognity:[
    {
      width: 2559,
      height: 1326,
      thumb: Cognity1Thumb,
      src: Cognity1,
      alt: "Cognity Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Cognity2Thumb,
      src: Cognity2,
      alt: "Cognity Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Cognity3Thumb,
      src: Cognity3,
      alt: "Cognity Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Cognity4Thumb,
      src: Cognity4,
      alt: "Cognity Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Cognity5Thumb,
      src: Cognity5,
      alt: "Cognity Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Cognity6Thumb,
      src: Cognity6,
      alt: "Cognity Screenshot #6",
    },
  ],
  mdcx:[
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx1Thumb,
      src: Mdcx1,
      alt: "Mdcx Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx2Thumb,
      src: Mdcx2,
      alt: "Mdcx Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx3Thumb,
      src: Mdcx3,
      alt: "Mdcx Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx4Thumb,
      src: Mdcx4,
      alt: "Mdcx Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx5Thumb,
      src: Mdcx5,
      alt: "Mdcx Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx6Thumb,
      src: Mdcx6,
      alt: "Mdcx Screenshot #6",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx7Thumb,
      src: Mdcx7,
      alt: "Mdcx Screenshot #7",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Mdcx8Thumb,
      src: Mdcx8,
      alt: "Mdcx Screenshot #8",
    },
  ],
  mdcxcampaign:[
    {
      width: 2559,
      height: 1326,
      thumb: MdcxCampaign1Thumb,
      src: MdcxCampaign1,
      alt: "Mdcx Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: MdcxCampaign2Thumb,
      src: MdcxCampaign2,
      alt: "Mdcx Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: MdcxCampaign3Thumb,
      src: MdcxCampaign3,
      alt: "Mdcx Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: MdcxCampaign4Thumb,
      src: MdcxCampaign4,
      alt: "Mdcx Screenshot #4",
    },
       {
      width: 2559,
      height: 1326,
      thumb: Mdcx8Thumb,
      src: Mdcx8,
      alt: "Mdcx Screenshot #8",
    },
  ],
  medbot:[
    {
      width: 2559,
      height: 1326,
      thumb: Medbot1Thumb,
      src: Medbot1,
      alt: "Mdcx Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot2Thumb,
      src: Medbot2,
      alt: "Mdcx Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot3Thumb,
      src: Medbot3,
      alt: "Mdcx Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot4Thumb,
      src: Medbot4,
      alt: "Mdcx Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot5Thumb,
      src: Medbot5,
      alt: "Mdcx Screenshot #5",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot6Thumb,
      src: Medbot6,
      alt: "Mdcx Screenshot #6",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot7Thumb,
      src: Medbot7,
      alt: "Mdcx Screenshot #7",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot8Thumb,
      src: Medbot8,
      alt: "Mdcx Screenshot #8",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot9Thumb,
      src: Medbot9,
      alt: "Mdcx Screenshot #9",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Medbot10Thumb,
      src: Medbot10,
      alt: "Mdcx Screenshot #10",
    },
  ],
  karku:[
    {
      width: 2559,
      height: 1326,
      thumb: Karku1Thumb,
      src: Karku1,
      alt: "Karku Screenshot #1",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Karku2Thumb,
      src: Karku2,
      alt: "Karku Screenshot #2",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Karku3Thumb,
      src: Karku3,
      alt: "Karku Screenshot #3",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Karku4Thumb,
      src: Karku4,
      alt: "Karku Screenshot #4",
    },
    {
      width: 2559,
      height: 1326,
      thumb: Karku5Thumb,
      src: Karku5,
      alt: "Karku Screenshot #5",
    },
  ],
  articles: {
    blog2: {
      width: 2559,
      height: 1326,
      thumb: Blog2,
      src: Blog2,
      alt: "blog",
    },
    blog3: {
      width: 2559,
      height: 1326,
      thumb: Blog3,
      src: Blog3,
      alt: "blog",
    },
    blog4: {
      width: 2559,
      height: 1326,
      thumb: Blog4,
      src: Blog4,
      alt: "blog",
    },
  },
};
